/**
 * CJS interop shim para uuid.
 *
 * Problema: @material-table/core (dependencia transitiva de
 * @backstage/core-components) usa el patrón CJS legacy:
 *
 *   var _uuid = _interopRequireDefault(require("uuid"));
 *   uuid: row.uuid || _uuid["default"].v4()
 *
 * uuid v9+ marca su bundle con __esModule:true pero NO expone .default,
 * por lo que _interopRequireDefault devuelve el módulo tal cual y
 * _uuid.default queda undefined → TypeError en runtime (catálogo).
 *
 * Solución: este shim re-exporta uuid (vía alias uuid-real) SIN __esModule,
 * provocando que _interopRequireDefault envuelva el módulo como
 * { default: shim }, restaurando _uuid.default.v4().
 *
 * Activado vía resolution "uuid": "portal:./shims/uuid" en runtime/package.json.
 * Ver AGENTS.md > ANTI-PATTERNS.
 */

"use strict";

/* eslint-disable */
const uuid = require("uuid-real");

// Re-export sin Object.defineProperty(exports,'__esModule',{value:true}).
/**
 * Surface mínima: solo v1 y v4 (los únicos que usa el código del repo y
 * @material-table/core). Se omiten v3/v5/v6 intencionadamente porque:
 *   1. Nadie los usa en runtime/ ni en las deps de Backstage que bundleamos.
 *   2. El fix del CVE GHSA-w5hq-g745-h8pq (CVE-2026-41907, buffer bounds
 *      check en v3/v5/v6) llegó en uuid 11.1.1, que vuelve a publicar
 *      bundle CJS (exports.require → dist/cjs). uuid-real apunta a
 *      ^11.1.1; al no exportar v3/v5/v6 desde este shim, el código
 *      vulnerable queda inalcanzable. No subir a uuid v12+ (dist-tags
 *      "legacy-*" confirman que solo 11.x mantiene el contrato CJS).
 * Si en el futuro algún consumidor los necesita, fallará en build con un
 * `undefined is not a function` claramente atribuible aquí.
 */
module.exports = {
  v1: uuid.v1,
  v4: uuid.v4,
  NIL: uuid.NIL,
  parse: uuid.parse,
  stringify: uuid.stringify,
  validate: uuid.validate,
  version: uuid.version,
};
